export enum NotificationResources {
  Account = 'Account',
  Application = 'Application',
  Approval = 'Approval',
  ClientApplication = 'ClientApplication',
  Deliverable = 'Deliverable',
  DeliverableComment = 'DeliverableComment',
  Milestone = 'Milestone',
  MilestoneComment = 'MilestoneComment',
  PartnerProposal = 'PartnerProposal',
  Project = 'Project',
  Schedule = 'Schedule',
  Task = 'Task',
  TaskComment = 'TaskComment',
  Title = 'Title',
  User = 'User',
  ApplicationForm = 'ApplicationForm',
}
